// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  display: inline-flex;
}

.tooltipBubble {
  background: #0009;
  backdrop-filter: blur(10px);
  border-radius: 6px;
  color: #fff;
  font-size: var(--font-size-small);
  line-height: 1.4;
  max-width: 220px;
  opacity: 0;
  padding: 6px 10px;
  pointer-events: none;
  position: fixed;
  text-align: center;
  transform: translateY(4px);
  transition:
    opacity 0.15s ease,
    transform 0.15s ease;
  visibility: hidden;
  width: max-content;
}

.tooltipBubble::after {
  backdrop-filter: blur(10px);
  border: 5px solid transparent;
  border-top-color: #0009;
  content: '';
  left: var(--arrow-left);
  position: absolute;
  top: 100%;
  transform: translateX(-50%);
}

/* When flipped below the anchor, the arrow moves to the bubble's top edge and
   points up instead of down. */
.tooltipBubble.flipped::after {
  border-top-color: transparent;
  border-bottom-color: #0009;
  top: auto;
  bottom: 100%;
}

.visible {
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B;;wBAEsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;+BAC+B;AAC/B;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,mBAAmB;AACrB","sourcesContent":[".tooltip {\n  display: inline-flex;\n}\n\n.tooltipBubble {\n  background: #0009;\n  backdrop-filter: blur(10px);\n  border-radius: 6px;\n  color: #fff;\n  font-size: var(--font-size-small);\n  line-height: 1.4;\n  max-width: 220px;\n  opacity: 0;\n  padding: 6px 10px;\n  pointer-events: none;\n  position: fixed;\n  text-align: center;\n  transform: translateY(4px);\n  transition:\n    opacity 0.15s ease,\n    transform 0.15s ease;\n  visibility: hidden;\n  width: max-content;\n}\n\n.tooltipBubble::after {\n  backdrop-filter: blur(10px);\n  border: 5px solid transparent;\n  border-top-color: #0009;\n  content: '';\n  left: var(--arrow-left);\n  position: absolute;\n  top: 100%;\n  transform: translateX(-50%);\n}\n\n/* When flipped below the anchor, the arrow moves to the bubble's top edge and\n   points up instead of down. */\n.tooltipBubble.flipped::after {\n  border-top-color: transparent;\n  border-bottom-color: #0009;\n  top: auto;\n  bottom: 100%;\n}\n\n.visible {\n  opacity: 1;\n  transform: translateY(0);\n  visibility: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
